import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Notice } from '../../bx-notices/notices.model';

@Component({
    selector: 'app-bx-notifications-results-panel',
    templateUrl: './bx-notifications-results-panel.component.html',
    styleUrls: ['./bx-notifications-results-panel.component.scss'],
    standalone: false,
})
export class BxNotificationsResultsPanelComponent implements OnInit {
    @Input()
    // @ts-ignore TS2564
    notices: Notice[];

    @Output()
    noticeClick = new EventEmitter();

    @Output()
    markAsReadChange = new EventEmitter();

    @Output()
    noticeClose = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    onNoticeClick(notice: Notice) {
        this.noticeClick.emit(notice);
    }

    onMarkAsReadChanged(isRead: boolean, noticeId: string) {
        this.markAsReadChange.emit({ isRead, noticeId });
    }

    onNoticeClose(noticeId: string) {
        this.noticeClose.emit(noticeId);
    }
}
